module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.opened) ? _c('div', {
    staticClass: "contents"
  }, [_c('div', {
    staticClass: "scroll-height"
  }, [(!_vm.loading) ? _vm._l((_vm.types), function(type) {
    return _c('list-slot', {
      key: type.id,
      attrs: {
        "main-text": type.name,
        "sub-text": type.isValid ? type.description : type.unavailableMsg,
        "disabled": !type.isValid,
        "offers": _vm.offersForType(type),
        "selected": false
      },
      on: {
        "click": function($event) {
          _vm.setType(type)
        }
      }
    })
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _vm._l((_vm.placeholderCount), function(n) {
    return _c('list-slot', {
      key: 'typePlaceholder' + n,
      attrs: {
        "placeholder": true
      }
    })
  }) : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-636128cf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/typeStage.vue
// module id = 602
// module chunks = 0